import React from 'react'
import './Sidebar.css'
import { useNavigate } from 'react-router-dom'
import { SidebarData } from './SidebarData'
import logo from '../../../assets/images/inferenz-logo.svg'

export const Sidebar = () => {
  const navigate = useNavigate()
  const logout = () => {
    localStorage.clear()
    navigate('/ADMS')
  }
  return (
    <div>
      <div className="sidemenu">
        <div className="sidemenuLogo">
          <img src={logo} alt="" height={25} />
        </div>

        <div className="sideMenuWraper">
          <div className="sidemenuItems">
            <ul className="sidemenuList">
              {SidebarData.map((val, index) => {
                return (
                  <li
                    key={index}
                    className="sidemenuItem w-100"
                    id={window.location.pathname === val.link ? 'active' : ''}
                    onClick={() => {
                      navigate(val.link)
                    }}
                  >
                    <div className="sidebaricon">{val.icon}</div>
                    <div
                      className="sidetitle  w-100"
                      data-bs-target={
                        val.title === 'Logout' ? '#exampleModal' : ''
                      }
                      data-bs-toggle={val.title === 'Logout' ? 'modal' : ''}
                    >
                      {val.title}
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
      <div
        className="modal"
        tabIndex="-1"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Alert</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to Logout from Intranet ?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  logout()
                }}
                data-bs-dismiss="modal"
              >
                Yes
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
